"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
var _log = require("@/utils/log");
var _training = require("@/api/training");
var yup = _interopRequireWildcard(require("yup"));
var _index = require("./index");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _index2 = _interopRequireDefault(require("../../../../components/ActivationCode/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TrainingDetail',
  components: {
    TrainingGenInfo: _index.TrainingGenInfo,
    TrainingResource: _index.TrainingResource,
    TrainingCode: _index.TrainingCode,
    TrainingTeam: _index.TrainingTeam,
    TrainingStaff: _index.TrainingStaff,
    TrainingSession: _index.TrainingSession,
    TrainingBaseline: _index.TrainingBaseline,
    ActivationCode: _index2.default
  },
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      fullscreenloading: false,
      teams: null,
      // participants
      reportRecipients: null,
      isCreatedRecord: false,
      // editType: this.displayType,
      fromId: '',
      trainingForm: {
        id: '',
        title: '',
        publish: '',
        start: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        end: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        expiry: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        channel: '',
        webinarName: '',
        webinarKey: '',
        webinarPasscode: '',
        estimatedParticipantCount: 0,
        address: {
          address1: '',
          address2: '',
          city: '',
          region: '',
          postalCode: '',
          country: ''
        },
        internal: {
          title: '',
          opportunityNumber: '',
          clientName: '',
          remark: ''
        },
        feedbackUrl: '',
        locale: 'en',
        imageUrl: '',
        description: '',
        skills: [],
        resources: [],
        assessments: [],
        /* no use now */
        coachAssessments: [],
        /* no use now */
        staff: [],
        tags: [],
        sessions: []
        /* teams: [] */ /* do not pass the element to add or save request, otherwise it will overide the value in DB */
      }
    };
  },
  computed: {
    validateSchema() {
      return yup.object().shape({
        title: yup.string().required(),
        description: yup.string().required()
      });
    },
    genInfo() {
      return {
        id: this.trainingForm.id,
        title: this.trainingForm.title,
        publish: this.trainingForm.publish,
        start: this.trainingForm.start,
        end: this.trainingForm.end,
        // expiry: this.trainingForm.expiry,
        expiry: this.trainingForm.end,
        address: this.trainingForm.address,
        locale: 'en',
        imageUrl: this.trainingForm.imageUrl,
        description: this.trainingForm.description,
        tags: this.trainingForm.tags,
        internal: this.trainingForm.internal,
        feedbackUrl: this.trainingForm.feedbackUrl,
        channel: this.trainingForm.channel,
        webinarName: this.trainingForm.webinarName,
        webinarKey: this.trainingForm.webinarKey,
        webinarPasscode: this.trainingForm.webinarPasscode,
        estimatedParticipantCount: this.trainingForm.estimatedParticipantCount
      };
    },
    isShowGeneral() {
      if (this.displayType === 'create') {
        return true;
      } else {
        return this.trainingForm.id;
      }
    },
    isShowModule() {
      if (this.displayType === 'create') {
        return true;
      } else {
        return this.trainingForm.id;
      }
    },
    isPublish() {
      const user = (0, _cookie.getCookie)('ROLES');
      // override the rule if it is root
      if (user.indexOf('root') >= 0) return false;
      return this.trainingForm.publish === 'published' || this.trainingForm.publish === 'archived';
    }
  },
  created() {
    if (this.displayType === 'edit') {
      const id = typeof this.$route.params.id === 'undefined' ? this.trainingForm.id : this.$route.params.id;
      this.editType = 'edit';
      this.fromId = typeof this.$route.query.fromId === 'undefined' ? '' : this.$route.query.fromId;
      this.getTraining(id, false); // copy mode is false
      // console.log('Log', this.trainingForm)
      // console.log('Parent created hook run edit', this.trainingForm)
    } else if (this.displayType === 'createfromcopy') {
      this.fromId = typeof this.$route.query.fromId === 'undefined' ? '' : this.$route.query.fromId;
      this.getTraining(this.fromId, true);
      // console.log('copy Form', this.trainingForm)
    } else {
      // create from new
      this.teams = [];
      this.reportRecipients = [];
      this.fromId = '';
      // console.log('Parent created hook run new', this.trainingForm)
    }
  },
  methods: {
    doBack() {
      this.$router.push('/training/index');
    },
    doAddSave(status) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.trainingForm.publish = status;

      // validate
      if (this.trainingForm.title === '') {
        this.fullscreenloading = false;
        const msg = this.$i18n.t('otrTraining.errorMessage1');
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.trainingForm.start.utc === '' || this.trainingForm.end.utc === '' || this.trainingForm.expiry.utc === '') {
        this.fullscreenloading = false;
        const msg = this.$i18n.t('otrTraining.errorMessage2');
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.trainingForm.start.timezone === '' || this.trainingForm.end.timezone === '' || this.trainingForm.expiry.timezone === '') {
        this.fullscreenloading = false;
        const msg = this.$i18n.t('otrTraining.errorMessage3');
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }

      // Reset Id to '' if copy
      if (this.trainingForm.id === 'copy') {
        this.trainingForm.id = '';
      }

      // submit
      if (this.trainingForm.id === '') {
        (0, _training.createTraining)(token, this.trainingForm).then(response => {
          (0, _log.showDebugLog)('training-create-response', response);
          this.fullscreenloading = false;
          this.trainingForm.id = response.data.id;
          this.trainingForm.publish = response.data.publish;

          // console.log('Success create', this.displayType)
          const msg = `${this.$i18n.t('otrTraining.training')} ${response.data.id} ${this.$i18n.t('otrTraining.isCreated')}`;
          (0, _log.displayPopupMessage)(msg, 'success');
          this.isCreatedRecord = true;
          if (this.displayType === 'createfromcopy' || this.displayType === 'create') {
            this.$router.push(`/training/edit/${response.data.id}`);
          }
          (0, _ga.writeGaEvent)(this, 'Training', `${_lifehikesInitData.userEvent.training.create}`, oEmail, `Training Id: ${this.trainingForm.id}`);
        }).catch(error => {
          (0, _log.showDebugLog)('training-create-error', error);
          this.fullscreenloading = false;
          // this.$message({ type: 'error', message: error })
          (0, _log.displayPopupMessage)(error, 'error');
          // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
        });
      } // else {
      // this.doSave(status)
      // }
    },
    doSave(status) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = typeof this.$route.params.id === 'undefined' ? this.trainingForm.id : this.$route.params.id;
      this.trainingForm.publish = status;

      // validate
      if (this.trainingForm.title === '') {
        this.fullscreenloading = false;
        const msg = this.$i18n.t('otrTraining.errorMessage1');
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.trainingForm.start.utc === '' || this.trainingForm.end.utc === '' || this.trainingForm.expiry.utc === '') {
        this.fullscreenloading = false;
        const msg = this.$i18n.t('otrTraining.errorMessage2');
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }

      // submit
      (0, _log.showDebugLog)('Save Form', this.trainingForm);
      (0, _training.updateTrainingById)(token, id, this.trainingForm).then(response => {
        (0, _log.showDebugLog)('training-create-response', response);
        this.fullscreenloading = false;
        this.trainingForm.id = response.data.id;
        this.trainingForm.publish = response.data.publish;
        const msg = `${this.$i18n.t('otrTraining.training')} ${response.data.id} ${this.$i18n.t('otrTraining.isUpdated')}`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'Training', `${_lifehikesInitData.userEvent.training.edit}`, oEmail, `Training Id: ${this.trainingForm.id}`);
      }).catch(error => {
        (0, _log.showDebugLog)('training-create-error', error);
        this.fullscreenloading = false;
        // this.$message({ type: 'error', message: error })
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, message: error.response.data.message })
      });
    },
    doCancel() {
      this.getTraining();
    },
    getTraining(id, isCopy) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _training.getTrainingById)(token, id).then(response => {
        const d = response.data;

        // check error and return immediate
        if (typeof d.id === 'undefined') {
          this.fullscreenloading = false;
          const msg = this.$i18n.t('otrTraining.cannotGetTraining');
          (0, _log.displayPopupMessage)(msg, 'error');
          // this.$message({ type: 'error', message: 'Cannot get the training, please contact to system administrator' })

          return;
        }
        (0, _log.showDebugLog)('Training-getTrainingById-response', d);
        this.trainingForm.id = isCopy ? 'copy' : d.id;

        // title
        if (isCopy) {
          this.trainingForm.title = this.$route.query.t === 'true' ? d.title : '';
        } else {
          this.trainingForm.title = typeof d.title === 'undefined' ? '' : d.title;
        }

        // internal title
        if (isCopy) {
          this.trainingForm.internal.title = this.$route.query.it === 'true' ? d.internal.title : '';
        } else {
          this.trainingForm.internal.title = typeof d.internal === 'undefined' ? '' : d.internal.title;
        }

        // description
        if (isCopy) {
          this.trainingForm.description = this.$route.query.d === 'true' ? d.description : '';
        } else {
          this.trainingForm.description = typeof d.description === 'undefined' ? '' : d.description;
        }

        // client Name
        if (isCopy) {
          this.trainingForm.internal.clientName = this.$route.query.cn === 'true' ? d.internal.clientName : '';
        } else {
          this.trainingForm.internal.clientName = typeof d.internal === 'undefined' ? '' : d.internal.clientName;
        }

        // resources
        if (isCopy) {
          this.trainingForm.resources = this.$route.query.r === 'true' ? d.resources : [];
        } else {
          this.trainingForm.resources = typeof d.resources === 'undefined' ? [] : d.resources;
        }

        // tags
        if (isCopy) {
          this.trainingForm.tags = this.$route.query.tag === 'true' ? d.tags : [];
        } else {
          this.trainingForm.tags = typeof d.tags === 'undefined' ? [] : d.tags;
        }

        // channel : webinar Info or Address
        if (isCopy) {
          this.trainingForm.channel = this.$route.query.w === 'true' ? d.channel : '';
          this.trainingForm.webinarName = this.$route.query.w === 'true' ? d.webinarName : '';
          this.trainingForm.webinarKey = this.$route.query.w === 'true' ? d.webinarKey : '';
          this.trainingForm.webinarPasscode = this.$route.query.w === 'true' ? d.webinarPasscode : '';
          if (this.$route.query.w === 'true') {
            this.trainingForm.address.address1 = d.address.address1;
            this.trainingForm.address.address2 = d.address.address2;
            this.trainingForm.address.city = d.address.city;
            this.trainingForm.address.region = d.address.region;
            this.trainingForm.address.postalCode = d.address.postalCode;
            this.trainingForm.address.country = d.address.country;
          } else {
            this.trainingForm.address = {
              address1: '',
              address2: '',
              city: '',
              region: '',
              postalCode: '',
              country: ''
            };
          }
        } else {
          this.trainingForm.channel = typeof d.channel === 'undefined' ? '' : d.channel;
          this.trainingForm.webinarName = typeof d.webinarName === 'undefined' ? '' : d.webinarName;
          this.trainingForm.webinarKey = typeof d.webinarKey === 'undefined' ? '' : d.webinarKey;
          this.trainingForm.webinarPasscode = typeof d.webinarPasscode === 'undefined' ? '' : d.webinarPasscode;
          this.trainingForm.address.address1 = typeof d.address.address1 === 'undefined' ? '' : d.address.address1;
          this.trainingForm.address.address2 = typeof d.address.address2 === 'undefined' ? '' : d.address.address2;
          this.trainingForm.address.city = typeof d.address.city === 'undefined' ? '' : d.address.city;
          this.trainingForm.address.region = typeof d.address.region === 'undefined' ? '' : d.address.region;
          this.trainingForm.address.postalCode = typeof d.address.postalCode === 'undefined' ? '' : d.address.postalCode;
          this.trainingForm.address.country = typeof d.address.country === 'undefined' ? '' : d.address.country;
        }

        // remark
        this.trainingForm.internal.remark = isCopy ? '' : typeof d.internal === 'undefined' ? '' : d.internal.remark;

        // feedback url
        this.trainingForm.feedbackUrl = isCopy ? '' : typeof d.feedbackUrl === 'undefined' ? '' : d.feedbackUrl;

        // opportunityNumber
        this.trainingForm.internal.opportunityNumber = isCopy ? '' : typeof d.internal === 'undefined' ? '' : d.internal.opportunityNumber;

        // estimated Participant Count
        this.trainingForm.estimatedParticipantCount = isCopy ? 0 : typeof d.estimatedParticipantCount === 'undefined' ? 0 : d.estimatedParticipantCount;

        // publish
        this.trainingForm.publish = isCopy ? '' : typeof d.publish === 'undefined' ? '' : d.publish;

        // start date and end date
        if (isCopy) {
          if (this.$route.query.e === 'true') {
            this.trainingForm.start.utc = typeof d.start.utc === 'undefined' ? '' : d.start.utc;
            this.trainingForm.start.local = typeof d.start.local === 'undefined' ? '' : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
            this.trainingForm.start.timezone = typeof d.start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.start.timezone;
            this.trainingForm.end.utc = typeof d.end.utc === 'undefined' ? '' : d.end.utc; // d.end.utc.toISOString()
            this.trainingForm.end.local = typeof d.end.local === 'undefined' ? '' : d.end.local; // moment(d.end.local).tz(moment.tz.guess()).toString()
            this.trainingForm.end.timezone = typeof d.end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.end.timezone;
          } else {
            this.trainingForm.start = {
              utc: '',
              timezone: _momentTimezone.default.tz.guess(),
              local: ''
            };
            this.trainingForm.end = {
              utc: '',
              timezone: _momentTimezone.default.tz.guess(),
              local: ''
            };
          }
        } else {
          // start date
          if (typeof d.start === 'undefined') {
            this.trainingForm.start = {
              utc: '',
              timezone: _momentTimezone.default.tz.guess(),
              local: ''
            };
          } else {
            this.trainingForm.start.utc = typeof d.start.utc === 'undefined' ? '' : d.start.utc;
            this.trainingForm.start.local = typeof d.start.local === 'undefined' ? '' : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
            this.trainingForm.start.timezone = typeof d.start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.start.timezone;
          }

          // end date
          if (typeof d.end === 'undefined') {
            this.trainingForm.end = {
              utc: '',
              timezone: _momentTimezone.default.tz.guess(),
              local: ''
            };
          } else {
            this.trainingForm.end.utc = typeof d.end.utc === 'undefined' ? '' : d.end.utc; // d.end.utc.toISOString()
            this.trainingForm.end.local = typeof d.end.local === 'undefined' ? '' : d.end.local; // moment(d.end.local).tz(moment.tz.guess()).toString()
            this.trainingForm.end.timezone = typeof d.end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.end.timezone;
          }
        }

        // training session
        if (isCopy) {
          if (this.$route.query.s === 'true') {
            this.trainingForm.sessions = d.sessions;
            // training - session event date
            if (this.$route.query.sd === 'true') {
              for (var s = 0; s < d.sessions.length; s++) {
                delete d.sessions[s].id;
                if (typeof d.sessions[s].start.utc === 'undefined' || d.sessions[s].start.utc == null) {
                  d.sessions[s].start.utc = '';
                } else {
                  d.sessions[s].start.utc = typeof d.sessions[s].start.utc === 'undefined' ? '' : d.sessions[s].start.utc; // d.end.utc.toISOString()
                  d.sessions[s].start.local = typeof d.sessions[s].start.local === 'undefined' ? '' : d.sessions[s].start.local; // moment(d.sessions[s].start.local).tz(moment.tz.guess()).toString()
                  d.sessions[s].start.timezone = typeof d.sessions[s].start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.sessions[s].start.timezone;
                }
                if (typeof d.sessions[s].end.utc === 'undefined' || d.sessions[s].end.utc == null) {
                  d.sessions[s].end.utc = '';
                } else {
                  d.sessions[s].end.utc = typeof d.sessions[s].end.utc === 'undefined' ? '' : d.sessions[s].end.utc; // d.end.utc.toISOString()
                  d.sessions[s].end.local = typeof d.sessions[s].end.local === 'undefined' ? '' : d.sessions[s].end.local; // moment(d.sessions[s].end.local).tz(moment.tz.guess()).toString()
                  d.sessions[s].end.timezone = typeof d.sessions[s].end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.sessions[s].end.timezone;
                }
                if (typeof d.sessions[s].recordingStart.utc === 'undefined' || d.sessions[s].recordingStart.utc == null) {
                  d.sessions[s].recordingStart.utc = '';
                } else {
                  d.sessions[s].recordingStart.utc = typeof d.sessions[s].recordingStart.utc === 'undefined' ? '' : d.sessions[s].recordingStart.utc; // d.end.utc.toISOString()
                  d.sessions[s].recordingStart.local = typeof d.sessions[s].recordingStart.local === 'undefined' ? '' : d.sessions[s].recordingStart.local; // moment(d.sessions[s].recordingStart.local).tz(moment.tz.guess()).toString()
                  d.sessions[s].recordingStart.timezone = typeof d.sessions[s].recordingStart.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.sessions[s].recordingStart.timezone;
                }
                if (typeof d.sessions[s].recordingEnd.utc === 'undefined' || d.sessions[s].recordingEnd.utc == null) {
                  d.sessions[s].recordingEnd.utc = '';
                } else {
                  d.sessions[s].recordingEnd.utc = typeof d.sessions[s].recordingEnd.utc === 'undefined' ? '' : d.sessions[s].recordingEnd.utc; // d.end.utc.toISOString()
                  d.sessions[s].recordingEnd.local = typeof d.sessions[s].recordingEnd.local === 'undefined' ? '' : d.sessions[s].recordingEnd.local; // moment(d.sessions[s].recordingEnd.local).tz(moment.tz.guess()).toString()
                  d.sessions[s].recordingEnd.timezone = typeof d.sessions[s].recordingEnd.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.sessions[s].recordingEnd.timezone;
                }
              }
            } else {
              for (s = 0; s < d.sessions.length; s++) {
                d.sessions[s].start = {
                  utc: '',
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ''
                };
                d.sessions[s].end = {
                  utc: '',
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ''
                };
                d.sessions[s].recordingStart = {
                  utc: '',
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ''
                };
                d.sessions[s].recordingEnd = {
                  utc: '',
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ''
                };
                delete d.sessions[s].id;
              }
            }
          } else {
            this.trainingForm.sessions = [];
          }
        } else {
          this.trainingForm.sessions = typeof d.sessions === 'undefined' ? [] : d.sessions;
          for (s = 0; s < this.trainingForm.sessions.length; s++) {
            if (typeof this.trainingForm.sessions[s].start.utc === 'undefined' || this.trainingForm.sessions[s].start.utc == null) {
              this.trainingForm.sessions[s].start.utc = '';
            } else {
              this.trainingForm.sessions[s].start.utc = typeof this.trainingForm.sessions[s].start.utc === 'undefined' ? '' : this.trainingForm.sessions[s].start.utc; // d.end.utc.toISOString()
              this.trainingForm.sessions[s].start.local = typeof this.trainingForm.sessions[s].start.local === 'undefined' ? '' : this.trainingForm.sessions[s].start.local; // moment(this.trainingForm.sessions[s].start.local).tz(moment.tz.guess()).toString()
              this.trainingForm.sessions[s].start.timezone = typeof this.trainingForm.sessions[s].start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : this.trainingForm.sessions[s].start.timezone;
            }
            if (typeof this.trainingForm.sessions[s].end.utc === 'undefined' || this.trainingForm.sessions[s].end.utc == null) {
              this.trainingForm.sessions[s].end.utc = '';
            } else {
              this.trainingForm.sessions[s].end.utc = typeof this.trainingForm.sessions[s].end.utc === 'undefined' ? '' : this.trainingForm.sessions[s].end.utc; // d.end.utc.toISOString()
              this.trainingForm.sessions[s].end.local = typeof this.trainingForm.sessions[s].end.local === 'undefined' ? '' : this.trainingForm.sessions[s].end.local; // moment(this.trainingForm.sessions[s].end.local).tz(moment.tz.guess()).toString()
              this.trainingForm.sessions[s].end.timezone = typeof this.trainingForm.sessions[s].end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : this.trainingForm.sessions[s].end.timezone;
            }
            if (typeof this.trainingForm.sessions[s].recordingStart.utc === 'undefined' || this.trainingForm.sessions[s].recordingStart.utc == null) {
              this.trainingForm.sessions[s].recordingStart.utc = '';
            } else {
              this.trainingForm.sessions[s].recordingStart.utc = typeof this.trainingForm.sessions[s].recordingStart.utc === 'undefined' ? '' : this.trainingForm.sessions[s].recordingStart.utc; // d.end.utc.toISOString()
              this.trainingForm.sessions[s].recordingStart.local = typeof this.trainingForm.sessions[s].recordingStart.local === 'undefined' ? '' : this.trainingForm.sessions[s].recordingStart.local; // moment(this.trainingForm.sessions[s].recordingStart.local).tz(moment.tz.guess()).toString()
              this.trainingForm.sessions[s].recordingStart.timezone = typeof this.trainingForm.sessions[s].recordingStart.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : this.trainingForm.sessions[s].recordingStart.timezone;
            }
            if (typeof this.trainingForm.sessions[s].recordingEnd.utc === 'undefined' || this.trainingForm.sessions[s].recordingEnd.utc == null) {
              this.trainingForm.sessions[s].recordingEnd.utc = '';
            } else {
              this.trainingForm.sessions[s].recordingEnd.utc = typeof this.trainingForm.sessions[s].recordingEnd.utc === 'undefined' ? '' : this.trainingForm.sessions[s].recordingEnd.utc; // d.end.utc.toISOString()
              this.trainingForm.sessions[s].recordingEnd.local = typeof this.trainingForm.sessions[s].recordingEnd.local === 'undefined' ? '' : this.trainingForm.sessions[s].recordingEnd.local; // moment(this.trainingForm.sessions[s].recordingEnd.local).tz(moment.tz.guess()).toString()
              this.trainingForm.sessions[s].recordingEnd.timezone = typeof this.trainingForm.sessions[s].recordingEnd.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : this.trainingForm.sessions[s].recordingEnd.timezone;
            }
          }
          // console.log('training form session', this.trainingForm.sessions)
        }
        if (isCopy) {
          this.trainingForm.staff = [];
          this.reportRecipients = [];
          this.teams = [];
        } else {
          this.trainingForm.staff = d.staff;
          this.getTeam(token, d.id);
          this.reportRecipients = [];
          // this.getReportRecipients(token, d.id)
        }

        // no used in v.1.1 - expiry date
        if (isCopy) {
          this.trainingForm.expiry = {
            utc: '',
            timezone: _momentTimezone.default.tz.guess(),
            local: ''
          };
        } else {
          if (typeof d.expiry === 'undefined') {
            this.trainingForm.expiry = {
              utc: '',
              timezone: _momentTimezone.default.tz.guess(),
              local: ''
            };
          } else {
            this.trainingForm.expiry.utc = typeof d.expiry.utc === 'undefined' ? '' : d.expiry.utc; // d.expiry.utc.toISOString()
            this.trainingForm.expiry.timezone = typeof d.expiry.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.expiry.timezone;
          }
        }
        // no used in v.1.1
        this.trainingForm.locale = typeof d.locale === 'undefined' ? 'en' : d.locale;
        this.trainingForm.imageUrl = typeof d.imageUrl === 'undefined' ? '' : d.imageUrl;
        this.trainingForm.skills = typeof d.skills === 'undefined' ? [] : d.skills;

        // console.log('copy ilt item', this.trainingForm)
        this.fullscreenloading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('training-getTrainingById-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // const msg = (typeof error.response === 'undefined') ? error : error.response.data.message
        // this.$message({ type: 'error', showClose: true, message: msg })
      });
    },
    getTeam(token, id) {
      (0, _training.getTrainingTeams)(token, id).then(response => {
        (0, _log.showDebugLog)('ShowTeam', response.data.rows);
        this.teams = response.data.rows;
      }).catch(error => {
        (0, _log.showDebugLog)('GetTeam-API-error', error);
      });
    },
    getReportRecipients(token, id) {
      (0, _training.getTrainingManagerReportRecipients)(token, id).then(response => {
        (0, _log.showDebugLog)('ShowReportRecipients', response.data.recipients);
        this.reportRecipients = response.data.recipients;
      }).catch(error => {
        (0, _log.showDebugLog)('GetReportRecipients-API-error', error);
      });
    },
    updateParentGenInfo(info) {
      // do something
      this.trainingForm.id = info.id;
      this.trainingForm.title = info.title;
      this.trainingForm.publish = info.publish;
      this.trainingForm.start = info.start;
      this.trainingForm.end = info.end;
      this.trainingForm.expiry = info.expiry;
      this.trainingForm.address = info.address;
      this.trainingForm.locale = info.locale;
      this.trainingForm.imageUrl = info.imageUrl;
      this.trainingForm.description = info.description;
      this.trainingForm.tags = info.tags;
      this.trainingForm.feedbackUrl = info.feedbackUrl;
      this.trainingForm.channel = info.channel;
      this.trainingForm.webinarName = info.webinarName;
      this.trainingForm.webinarKey = info.webinarKey;
      this.trainingForm.webinarPasscode = info.webinarPasscode;
      this.trainingForm.internal = info.internal;
      this.trainingForm.estimatedParticipantCount = info.estimatedParticipantCount;
      (0, _log.showDebugLog)('Update trainingForm', this.trainingForm);
    },
    updateParentModule(mod) {
      this.trainingForm.skills = mod;
      (0, _log.showDebugLog)('Update ParentModule', mod);
    },
    updateParentResource(res) {
      (0, _log.showDebugLog)('Parent Resource', res);
      this.trainingForm.resources = res;
    },
    updateParentSession(session) {
      // showDebugLog('Parent Session', session)
      this.trainingForm.sessions = session;
    },
    updateParentStaff(staff) {
      (0, _log.showDebugLog)('Parent Staff', staff);
      this.trainingForm.staff = staff;
    },
    /* for el-tab */
    handleClick(tab, event) {
      // do something later
      // auto save when change tab
    },
    checkMandateFields() {
      // console.log("form", this.trainingForm.staff)
      var producer = _.find(this.trainingForm.staff, function (s) {
        return s.role === 'producer';
      });
      // console.log("producer", producer)
      // console.log("string length", _.trim(this.trainingForm.internal.opportunityNumber).length)
      if (typeof producer === 'undefined' || _.trim(this.trainingForm.internal.opportunityNumber).length == 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};